//src/common/data/generalinfo.js

import { getUserData } from '../../../auth/views/login/auth.api.js';

const { token, parentCustomerId } = getUserData() || {};

const baseUrl = 'https://dashboard.pressuretrack.co.za/api';

export const lookupSensorFallback = async (queryId) => {

  const id = queryId.trim();

  const endpoints = [
    {
      type: 'gateway',
      url: `${baseUrl}/gateway/search/${id}`,
      handler: async data => ({
        type: 'gateway',
        unit: null,
        item: { imei: data.imeiNumber, ...data }
      })
    },
    {
      type: 'sink',
      url: `${baseUrl}/sink/search/${id}`,
      handler: async data => ({
        type: 'sink',
        unit: null,
        item: data
      })
    },
    {
      type: 'repeater',
      url: `${baseUrl}/repeater/search/${id}`,
      handler: async data => ({
        type: 'repeater',
        unit: data.unitId ? { id: data.unitId, name: data.unitName } : null,
        item: data
      })
    },
    {
      type: 'signal-booster',
      url: `${baseUrl}/customer/${parentCustomerId}/booster?inclChild=true`,
      handler: async data => {
        console.log("BOOSTER DATA", data);

        const booster = data.results?.find(b => {
          const boosterId = b.Id ?? b.id ?? b.boosterId;
          console.log("Comparing", boosterId, "to", id.trim());
          return boosterId == id.trim(); // NOT ===
        });

        if (!booster) {
          console.warn(`Booster ID ${id} not found in result set`);
          return null;
        }

        return {
          type: 'signal-booster',
          unit: booster.unitId
            ? { unitId: booster.unitId, unitName: booster.unitName }
            : null,
          item: booster
        };
      }

    },
    {
      type: 'wheel',
      url: `${baseUrl}/sensor/search/${id}`,
      handler: async data => {
        const resolvedSensorId =
          data.sensorId ??
          data.Id ??
          data.id ??
          null;

        return {
          type: data.wheelId === '1180' ? 'unpaired' : 'wheel',
          unit: null,
          item: {
            ...data,
            Id: data.Id ?? resolvedSensorId,
            sensorId: resolvedSensorId,
            wheelId: data.wheelId ?? data.tyreId ?? null,
            repeater: data.repeater
          }
        };
      }
    }
  ];

  const fetchOptions = {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Accept': 'application/json'
    },
    credentials: 'include' // only if needed
  };

  for (const e of endpoints) {
    try {
      const res = await fetch(e.url, fetchOptions);

      if (!res.ok) continue;

      const data = await res.json();
      const result = await e.handler(data);
      console.log("Got handler result:", result);

      if (result) {
        return result;
      }

    } catch (err) {
      console.error("General Info Fallback fetch error:", err);
    }
  }

  return null;
};
